(function () {
// Warning!!! This an auto generated file. Any Changes will be lost. If u want to add or edit go to config.json 

a3_cabin_reports.constant("liveVersion", true);

a3_cabin_reports.constant("defaultCalendarDate", null);

a3_cabin_reports.constant("defaultBucketDate", null);

a3_cabin_reports.constant("refreshDelaySeconds", 120);

a3_cabin_reports.constant("mealCriteriaIsEnabled", false);

a3_cabin_reports.constant("isJumpseatRequestsVisible", true);

a3_cabin_reports.constant("apiUrl", "https://cabinreportuat.aegeanair.com/api/v1.14");

a3_cabin_reports.constant("azureADAuth", {
	"clientId": "6dac8675-e0b7-48f3-b8d0-2e12539b8f28",
	"tenantId": "00ab5264-f7ed-4d89-9011-19bf33ed8169",
	"authority": "https://login.microsoftonline.com/aegeancloud.onmicrosoft.com"
});

a3_cabin_reports.constant("customerIncidentQuestionIds", [
	220,
	222
]);

a3_cabin_reports.constant("enableFaceMasks", false);

a3_cabin_reports.constant("ssrCodes", [
	{
		"code": "AOXY",
		"description": "Airline Supplied Oxygen"
	},
	{
		"code": "AVIH",
		"description": "Animal in Hold"
	},
	{
		"code": "AVML",
		"description": "Vegetarian Hindu meal"
	},
	{
		"code": "BBNL",
		"description": "Baby meal request"
	},
	{
		"code": "BIKE",
		"description": "Request for carriage of bicycle"
	},
	{
		"code": "BLML",
		"description": "Bland meal request"
	},
	{
		"code": "BLND",
		"description": "Blind passenger information"
	},
	{
		"code": "CBBG",
		"description": "Bulky cabin baggage request"
	},
	{
		"code": "CHLD",
		"description": "Child information"
	},
	{
		"code": "CHML",
		"description": "Child Meal Request"
	},
	{
		"code": "DBML",
		"description": "Diabetic meal request"
	},
	{
		"code": "DEAF",
		"description": "Deaf passenger information"
	},
	{
		"code": "DEPA",
		"description": "Accompanied Deportee Information"
	},
	{
		"code": "DEPU",
		"description": "Deportee unaccompanied"
	},
	{
		"code": "DHCS",
		"description": "Deadhead crew seating"
	},
	{
		"code": "DPNA",
		"description": "Disabled passenger needing assistance"
	},
	{
		"code": "EMIG",
		"description": "Emigrant"
	},
	{
		"code": "ESAN",
		"description": "Passenger with emotional support/psychiatric"
	},
	{
		"code": "ESCD",
		"description": "Passenger escorting deportee"
	},
	{
		"code": "EXST",
		"description": "Request for extra seat"
	},
	{
		"code": "FAMS",
		"description": "Family seating"
	},
	{
		"code": "FPML",
		"description": "Fruit platter meal request"
	},
	{
		"code": "FRED",
		"description": "Meal and assist request"
	},
	{
		"code": "GFML",
		"description": "Gluten intolerant meal request"
	},
	{
		"code": "GPST",
		"description": "Group seating request"
	},
	{
		"code": "HAJJ",
		"description": "HAJJ Passengers"
	},
	{
		"code": "HNML",
		"description": "Hindu meal request"
	},
	{
		"code": "INAD",
		"description": "Inadmissable"
	},
	{
		"code": "INFT",
		"description": "Infant information"
	},
	{
		"code": "KSML",
		"description": "Kosher meal request"
	},
	{
		"code": "LCML",
		"description": "Low calorie meal request"
	},
	{
		"code": "LFML",
		"description": "Low fat meal request"
	},
	{
		"code": "LSML",
		"description": "Low salt meal request"
	},
	{
		"code": "MAAS",
		"description": "Meet and assist request"
	},
	{
		"code": "MEDA",
		"description": "Medical assistance information"
	},
	{
		"code": "MEQT",
		"description": "Medical equipment"
	},
	{
		"code": "MOML",
		"description": "Halaal meal request"
	},
	{
		"code": "NFML",
		"description": "No fish meal request"
	},
	{
		"code": "NLML",
		"description": "Low lactose meal request"
	},
	{
		"code": "NOML",
		"description": "Meal on board not required"
	},
	{
		"code": "PETC",
		"description": "Pet in cabin request"
	},
	{
		"code": "POXY",
		"description": "Passenger own oxygen"
	},
	{
		"code": "RVML",
		"description": "Vegetarian raw meal request"
	},
	{
		"code": "SEML",
		"description": "Seafood meal request"
	},
	{
		"code": "SFML",
		"description": "Seafood meal request"
	},
	{
		"code": "SPML",
		"description": "Special meal request"
	},
	{
		"code": "SVAN",
		"description": "Passenger with service animal in cabin"
	},
	{
		"code": "UMNR",
		"description": "Unaccompanied minor information"
	},
	{
		"code": "VGML",
		"description": "Vegetarian vegan meal request"
	},
	{
		"code": "VJML",
		"description": "Vegetarian Jain meal request"
	},
	{
		"code": "VLML",
		"description": "Vegetarian Lacto-Ovo meal request"
	},
	{
		"code": "VOML",
		"description": "Vegetarian Oriental meal request"
	},
	{
		"code": "WCBD",
		"description": "Wheelchair Dry-cell battery request"
	},
	{
		"code": "WCBW",
		"description": "Wheelchair Wet-cell battery request"
	},
	{
		"code": "WCHC",
		"description": "Wheelchair To seat request"
	},
	{
		"code": "WCHR",
		"description": "Wheelchair To aircraft door request"
	},
	{
		"code": "WCHS",
		"description": "Wheelchair Up/down stairs request"
	},
	{
		"code": "WCLB",
		"description": "Wheelchair - Lithium ion Battery"
	},
	{
		"code": "WCMP",
		"description": "Wheelchair Manual powered request"
	},
	{
		"code": "WCOB",
		"description": "Wheelchair On board request"
	},
	{
		"code": "WEAP",
		"description": "WEAP Firearms or ammunition booked & carried as checked"
	},
	{
		"code": "XBGS",
		"description": "DCS Excess Baggage Request"
	},
	{
		"code": "FAML",
		"description": "BC HB choice A"
	},
	{
		"code": "FBML",
		"description": "BC HB choice B"
	},
	{
		"code": "BFML",
		"description": "BC HML beef choice"
	},
	{
		"code": "CKML",
		"description": "BC HML chicken choice"
	},
	{
		"code": "FSML",
		"description": "BC HML fish choice"
	},
	{
		"code": "COML",
		"description": "Cold cut platter"
	},
	{
		"code": "DEML",
		"description": "Dessert choice"
	}
]);

a3_cabin_reports.constant("bookmarkThreshold", 15);

a3_cabin_reports.constant("turnArroundTimesAcTypes", [
	"319",
	"320",
	"321",
	"32Q",
	"32N",
	"32X"
]);

a3_cabin_reports.constant("waterUpliftSupportingAcTypes", [
	"319",
	"320",
	"321",
	"32Q",
	"32N",
	"32X"
]);

a3_cabin_reports.constant("enableWaterUpliftReporting", false);

a3_cabin_reports.constant("operationalPhases", [
	{
		"key": "3287",
		"value": "On Stand"
	},
	{
		"key": "3288",
		"value": "Towing"
	},
	{
		"key": "9242",
		"value": "Towing - Stand to Stand"
	},
	{
		"key": "9243",
		"value": "Towing - to/from maint"
	},
	{
		"key": "3289",
		"value": "Parked"
	},
	{
		"key": "3290",
		"value": "Pushback"
	},
	{
		"key": "3291",
		"value": "Taxi-out"
	},
	{
		"key": "3292",
		"value": "Take-off"
	},
	{
		"key": "3293",
		"value": "Initial Climb"
	},
	{
		"key": "3294",
		"value": "Climb"
	},
	{
		"key": "3295",
		"value": "Cruise"
	},
	{
		"key": "3296",
		"value": "Descent"
	},
	{
		"key": "3297",
		"value": "Holding"
	},
	{
		"key": "3298",
		"value": "Approach"
	},
	{
		"key": "3299",
		"value": "Landing"
	},
	{
		"key": "3300",
		"value": "Taxi-in"
	},
	{
		"key": "3301",
		"value": "Maintenance"
	},
	{
		"key": "3302",
		"value": "All"
	},
	{
		"key": "3303",
		"value": "In Aircraft"
	},
	{
		"key": "3304",
		"value": "In Position at Aircraft"
	},
	{
		"key": "3305",
		"value": "In Transit To / From Stand"
	},
	{
		"key": "3306",
		"value": "Moving on Stand"
	},
	{
		"key": "3307",
		"value": "Positioning to Aircraft"
	},
	{
		"key": "3308",
		"value": "Removing from Aircraft"
	},
	{
		"key": "3309",
		"value": "Other"
	},
	{
		"key": "3310",
		"value": "Hover"
	},
	{
		"key": "3311",
		"value": "In Flight"
	},
	{
		"key": "3312",
		"value": "Multiple"
	},
	{
		"key": "3313",
		"value": "Parked On / By Stand"
	},
	{
		"key": "9241",
		"value": "Arrival"
	},
	{
		"key": "9244",
		"value": "Arrival - Marshaling"
	},
	{
		"key": "9245",
		"value": "Arrival - Guidance"
	},
	{
		"key": "9246",
		"value": "Servicing"
	},
	{
		"key": "9247",
		"value": "Servicing - De-icing"
	},
	{
		"key": "9248",
		"value": "Servicing - Fueling"
	},
	{
		"key": "9249",
		"value": "Servicing - Catering"
	},
	{
		"key": "9250",
		"value": "Servicing - Lavatory"
	},
	{
		"key": "9251",
		"value": "Servicing - Water"
	},
	{
		"key": "9252",
		"value": "Servicing - Cleaning"
	},
	{
		"key": "9253",
		"value": "Servicing - Line Maint"
	},
	{
		"key": "9254",
		"value": "Servicing - Coning"
	},
	{
		"key": "9255",
		"value": "Servicing - GPU"
	},
	{
		"key": "9256",
		"value": "Servicing - PCA"
	},
	{
		"key": "9257",
		"value": "Servicing - Bridging"
	},
	{
		"key": "9258",
		"value": "Servicing - Chocking"
	},
	{
		"key": "9259",
		"value": "Loading"
	},
	{
		"key": "9260",
		"value": "Loading - Passenger"
	},
	{
		"key": "9261",
		"value": "Loading - Baggage"
	},
	{
		"key": "9262",
		"value": "Loading - Cargo"
	},
	{
		"key": "9263",
		"value": "Unloading"
	},
	{
		"key": "9264",
		"value": "Unloading - Passenger"
	},
	{
		"key": "9265",
		"value": "Unloading - Baggage"
	},
	{
		"key": "9266",
		"value": "Unloading - Cargo"
	}
]);

})();